module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Bold.8fec96a9.woff2";